(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["i3-account-dashboard"] && !Shopify.designMode) return;
  try {
    
function initI3Dashboard(){document.querySelectorAll('[data-i3-dashboard]').forEach(hub=>{if(hub.dataset.ready)return;hub.dataset.ready='true';const filters=hub.querySelector('[data-order-filters]');if(!filters)return;const orders=Array.from(hub.querySelectorAll('[data-order-state]'));const empty=hub.querySelector('[data-order-empty]');filters.hidden=false;filters.addEventListener('click',event=>{const button=event.target.closest('[data-order-filter]');if(!button)return;const group=button.dataset.orderFilter;filters.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));let count=0;orders.forEach(order=>{order.hidden=group!=='all'&&order.dataset.orderState!==group;if(!order.hidden)count++});empty.hidden=count>0})})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initI3Dashboard);else initI3Dashboard();document.addEventListener('shopify:section:load',initI3Dashboard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
            if ($('.jdgm-widget').length) {
                jdgm.customizeBadges()
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
